import api from '@config/api';
import type { LoginCredentials, AuthResponse, User } from '../types';

export interface LogoutResponse {
  message: string;
  azureLogoutUrl?: string;
}

const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3000/api/v1';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    return response.data;
  },

  devLogin: async (email: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/dev-login', { email });
    return response.data;
  },

  refresh: async (): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/refresh');
    return response.data;
  },

  logout: async (): Promise<LogoutResponse> => {
    const response = await api.post<LogoutResponse>('/auth/logout');
    return response.data;
  },

  getMe: async (): Promise<User> => {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },

  loginWithAzure: () => {
    window.location.href = `${API_BASE_URL}/auth/azure`;
  },
};
